import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'; 
import { Link } from 'react-router-dom'
import LazyLoad from 'react-lazyload'

import { dayRemaining, strDateToFrLong, urlToHost } from "../../utilities/FrontFunctions/AoxFrontFunctions"
import { CONST_EventTypes } from "../../data/const"

class ObjPushEventSession extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}
	render() {
		const {eventSession, pageEventDetail} = this.props;
        
		const DayRemaining = eventSession ? dayRemaining(eventSession.EventSession_StartDate) : -1;
        const ActiveState = !eventSession ? ""
                            : eventSession?.EventSession_Canceled ? "CANCELED"  
                            : eventSession?.EventRegistration_State === "ABSENT" ? "ABSENT"
                            : eventSession && DayRemaining < 0 ? "FINISHED" 
                            : eventSession?.EventRegistration_State === "ATTENTE" ? "WAITING"
                            : eventSession?.UserRegistered ? "REGISTERED"
                            : "OPEN";

		return (
			<>
				{ eventSession &&
					<div className={`obj_formation
						${' ' + CONST_EventTypes[eventSession.Event.EventType_Code].css}
						${' ' + eventSession.Event.Brand.Brand_CssClass}
                        ${' ' + ActiveState === "CANCELED" ? "is_canceled" 
                                : ActiveState === "ABSENT" ? "is_finished"
                                : ActiveState === "FINISHED" ? "is_finished"
                                : ActiveState === "WAITING" ? "is_waiting_list" 
                                : ActiveState === "REGISTERED" ? "is_registered" 
                                : ""
                        }`
					}>
						<div className="ctn_header-title">
                            <span>{eventSession.EventSession_HalfDayTypeName !== "" ? "Demi-journée de formation" : eventSession.Event.EventType_Name}</span>
						</div>

						<div className="ctn_row">
							<div className="ctn_text">
                                {(ActiveState === "WAITING" || ActiveState === "REGISTERED" || ActiveState === "OPEN") && (
									(DayRemaining > 0) ? 
                                        <div className="obj_jours-restant">J-{DayRemaining}</div>
                                    : (DayRemaining===0) &&
                                        <div className="obj_jours-restant">Aujourd'hui</div>
                                )}

								<p className="t_title">{eventSession.Event.Event_Title}{eventSession.EventSession_HalfDayTypeName !== "" && (" " + eventSession.EventSession_HalfDayTypeName)}</p>

								<ul className="list_infos">
									<li className="t_date">
                                        {eventSession.EventSession_EndDate != null
                                            ? `Du ${strDateToFrLong(eventSession.EventSession_StartDate)} Au ${strDateToFrLong(eventSession.EventSession_EndDate)}`
                                            : strDateToFrLong(eventSession.EventSession_StartDate)
                                        }
                                        {eventSession.EventSession_HalfDayTypeName !== "" ? <><br/>{eventSession.EventSession_HalfDayTypeName}</> : ""}
									</li>

									<li className="t_info">
                                        {eventSession.Event.EventType_Code === 'WEB' ? 
                                            eventSession?.EventSession_StartHour ? eventSession.EventSession_StartHour : "-"
                                        : 
                                            eventSession?.Place?.EventPlace_City ? eventSession.Place.EventPlace_City : "-"
                                        }
									</li>
								</ul>

                                {(ActiveState === "CANCELED") ? 
                                    <p className="t_statut">Evènement annulé</p>
                                : (ActiveState === "ABSENT") ? <>
                                    <Link to={`${pageEventDetail?.url}?id=${eventSession.Event.Event_Id}&idSession=${eventSession.EventSession_Id}`} className="obj_btn light">se réinscrire</Link>
                                    <p className="t_statut">Vous avez été absent à cette session</p>
                                </>
                                : ((ActiveState === "FINISHED") && eventSession?.EventRegistration_State === "PRESENT_2") ? 
                                    <p className="t_statut">Merci pour votre participation.</p>
                                : (ActiveState === "FINISHED") ? 
                                    <p className="t_statut">Événement passé</p>
                                : (ActiveState === "WAITING") ? <>
                                    <Link to={`${pageEventDetail?.url}?id=${eventSession.Event.Event_Id}&idSession=${eventSession.EventSession_Id}`} className="obj_btn light">gérer mon inscription</Link>
                                    <p className="t_statut">Vous êtes inscrit en liste d'attente.</p>
                                </>
                                : (ActiveState === "REGISTERED") ? <>
                                    <Link to={`${pageEventDetail?.url}?id=${eventSession.Event.Event_Id}&idSession=${eventSession.EventSession_Id}`} className="obj_btn light">gérer mon inscription</Link>
                                    <p className="t_statut">Vous êtes inscrit</p>
                                </>
                                : (ActiveState === "OPEN") &&
                                    <Link to={`${pageEventDetail?.url}?id=${eventSession.Event.Event_Id}&idSession=${eventSession.EventSession_Id}`} className="obj_btn">inscrivez-vous</Link>
                                }
							</div>

							<div className="ctn_image">
								<div className="ctn_visuel fade-in">
									<LazyLoad>
										<img src={urlToHost(eventSession.Event.Event_MediaUrl)} alt={eventSession.Event.Event_MediaAlt}/>
									</LazyLoad>
								</div>

								<div className="ctn_logo">
									<LazyLoad>
										<img src={urlToHost(eventSession.Event.Brand.Brand_LogoUrl)} alt={eventSession.Event.Brand.Brand_Name}/>
									</LazyLoad>
								</div>
							</div>
						</div>
					</div>
				}
			</>
		)
	}
}

export default withTranslation()(ObjPushEventSession)